export const enum EDateTemplate {
    Full = "yyyy-MM-dd'T'HH:mm:ss'Z'",
    CostDatePicker = "yyyy-MM-dd'T'",
    DayMonthYearDotted = 'dd.MM.yy',
    DayMonthYearLongDotted = 'dd.MM.yyyy',
    DayMonthYearLongTimeDotted = 'dd.MM.yyyy HH:mm',
    DayMonthYearShortTimeDotted = 'dd.MM.yy HH:mm',
    YearLongMonthShortDayDashed = 'yyyy-MM-dd',
    YearLongMonthShortDayDotted = 'yyyy.MM.dd',
    YearLongMonthShortDashed = 'yyyy-MM',
    DayMonthLongYearLongTime = 'dd MMMM yyyy HH:mm',
    MonthLongYearLong = 'LLLL yyyy',
    YearLong = 'yyyy',
    MonthLong = 'LLLL',
    Time = 'HH:mm',
    DayMonthLong = 'dd MMMM'
}
